module.exports = __webpack_public_path__ + "SP_SPS3-NewFriends-a40cfae5440f812d72a7f37dc15a137b.png";